export default __webpack_public_path__ + "static/media/background.a8f0ea38.png";